import { Card, type CardActionAreaProps, type CardProps } from "@mui/material"
import type { ComponentProps, ElementType } from "react"
import { safeMergeSx } from "../../../../utils"
import type { LinkBoxProps } from "./LinkBox"

const defaultBgcolor = "#ecf5ff"

export type CardLinkBoxSlotProps<RightIcon extends ElementType> = {
  card?: CardProps
  cardActionArea?: CardActionAreaProps
  rightIcon?: ComponentProps<RightIcon>
  linkBox?: LinkBoxProps["slotProps"]
}

export interface LinkCardProps extends CardProps {
  bgcolor?: string
}

export const LinkCard = ({ bgcolor, ...props }: LinkCardProps) => (
  <Card
    {...props}
    sx={safeMergeSx({ backgroundColor: bgcolor || defaultBgcolor }, props.sx)}
  />
)
